module.exports = __webpack_public_path__ + "img/geoscience_inline_white_500px3.5ce342e7.png";